import 'core-js/stable';
import 'regenerator-runtime/runtime';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ApolloClient, ApolloProvider, InMemoryCache } from '@apollo/client';
import { unregister } from './registerServiceWorker';

import App from './App';
import env from './helpers/env';
import Store from './store/index';
import { apaAnalytics, getCookie, LOG } from './helpers/utils';

// Get offerId
const offerId = parseInt(window.location.href.replace(/(http(s)?:\/\/)/g, '').split('/')[2], 10);
const isNossa = true;

LOG('offerId', offerId);
const uuid = getCookie(`apa-${offerId}`);

const client = new ApolloClient({
  uri: '/graphql',
  cache: new InMemoryCache(),
  credentials: 'include',
  onError: (response) => {
    const { networkError } = response;
    if (response.networkError) {
      if (networkError) {
        const errorLog = `${response.operation ? response.operation.operationName : ''} / ${
          response.networkError.statusCode
        } / ${response.networkError.bodyText}`;
        LOG('networkError', errorLog);
        apaAnalytics({
          event: 'errorNetwork',
          eventActionMessage: errorLog,
          eventLabelMessage: `${env()} - UUID: ${uuid}`,
        });
      }
    }
  },
});

const CustomStore = new Store();

// Wrap render in a function to HMR
const render = () => {
  ReactDOM.render(
    <Provider store={CustomStore.store}>
      <ApolloProvider client={client}>
        <App offerId={offerId || 0} receivedUUID={uuid} isNossa={isNossa} />
      </ApolloProvider>
    </Provider>,
    document.getElementById('root')
  );
};

render(App);
unregister();

// Webpack Hot Module Replacement API
if (module.hot) {
  module.hot.accept('./App', () => {
    render(App);
  });
}
